/**
 * Test IDs for QA automation.
 */
export const testIds = {
  forecastingReceiverDashboardAddTankReading: "forecasting-receiver-dashboard-add-tank-reading",
  forecastingReceiverDashboardMetricsNavigation: "forecasting-receiver-dashboard-metrics-navigation",
  forecastingReceiverDashboardSales: "forecasting-receiver-dashboard-sales",
  forecastingReceiverDashboardReadings: "forecasting-receiver-dashboard-readings",
  forecastingReceiverDashboardOrders: "forecasting-receiver-dashboard-orders",
  forecastingReceiverDashboardAddReading: "forecasting-receiver-dashboard-add-reading",

  forecastingReceiverDashboardOpenStorageFacility: "forecasting-receiver-dashboard-open-storage-facility",
} as const;
